import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { EnvService } from './services/env.service';
import { UniversalStorageService } from './services/universal-storage.service';
import { forwardRef, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { of } from 'rxjs';

export class LanguageLoader implements TranslateLoader {
    isPlatformBrowser: boolean;
    constructor(
        private http: HttpClient,
        private env: EnvService,
        @Inject(PLATFORM_ID) private platformId: any,
        @Inject(forwardRef(() => UniversalStorageService)) private storageService: UniversalStorageService
    ) { }
    
    getTranslation(lang: string): Observable<object> {
        // if (isPlatformBrowser(this.platformId)) {
            let language: string;
            if (lang === null || lang == 'undefined') {
                language = 'en-GB';
            }
            else {
                language = lang;
            }
            return this.http.get(this.env.siteApiUrl + 'web/siteTranslateLanguage/' + language + '/website');
        // } else {
            // Return an empty observable if not in a browser environment
            // return of({});
        // }
    }
}